module.exports = __webpack_public_path__ + "img/m-icon-6.332049b0.png";